import React from 'react';

function SendMessageBubble ({messageText}){
    return( 
        <div className='sendMessageContainer'>
            <div className="sendMessageBubble">
       {messageText}
      </div>
      <img className="userImage" src={`${process.env.REACT_APP_SITE_URL}/images/chat-bot-user.png`}></img>
      
    </div>
    );
}

export default SendMessageBubble;